import _config from '../config.json';
import firebaseConfigJson from '../firebaseConfig.json';

type Config = typeof _config;
type FirebaseConfig = typeof firebaseConfigJson;

const config = _config as unknown as Config;
const firebaseConfig = firebaseConfigJson as unknown as FirebaseConfig;

/**
 * Meta (Facebook / Instagram) OAuth client ids for creator social sign-up.
 *
 * Per-environment values come from the templated deploy config (`env/use.sh`),
 * like every other environment-scoped id — NOT a `config.env` branch here. The
 * app must match the one the apiserver's `echoMeMetaConfig` holds the secret
 * for: Instagram will not exchange a code minted by a different app. See
 * `functions/docs/creator-social-signup.md`.
 */
export interface SocialAuthConfig {
  /** Instagram app id (Instagram API with Instagram Login). */
  igClientId: string;
  /** Facebook classic App ID (FB.init / dialog/oauth client_id). */
  facebookAppId: string;
  /** Facebook Login-for-Business configuration id (grants messaging/pages scopes). */
  facebookConfigId: string;
}

const socialAuthConfig: SocialAuthConfig = {
  igClientId: config.metaIgClientId,
  facebookAppId: config.metaFacebookAppId,
  facebookConfigId: config.metaFacebookConfigId,
};

export { config, firebaseConfig, socialAuthConfig };
export type { Config, FirebaseConfig };
